Ext.define('SA.view.plugin.GridRowDragReorder', {
    alias: 'plugin.sa-grid-row-drag-reorder',
    extend: 'SA.view.plugin.DragReorder',
    pluginId: 'sa-grid-row-drag-reorder',

    dragScrolling: false,
    itemDragCls: 'sa-report-grid-row-header-drag',
    itemSelector: '.sa-report-grid-row-header',
    resetEvent: 'update:cells',

    afterRowMove: Ext.emptyFn,

    afterMove(oldIndex, newIndex) {
        this.afterRowMove(this.dragData, newIndex - oldIndex);
    },

    beforeDrag(itemEl) {
        var grid = this.cmp,
            tr = Ext.fly(itemEl).findParent('tr'),
            row = grid.findByEl(grid.lockedRows, tr) || grid.findByEl(grid.rows, tr);

        this.dragData = row.data;

        this.getRowCellsByElement(itemEl).forEach(cell => {
            Ext.fly(cell.el).addCls('sa-report-grid-cell-row-drag');
        });
    },

    getParentEl() {
        var grid = this.cmp;

        return grid.lockedColumns.length ? grid.lockedWrap.dom : grid.normalWrap.dom;
    },

    getRowCellsByElement(el) {
        var grid = this.cmp,
            tr = Ext.fly(el).findParent('tr'),
            mainRow = grid.findByEl(grid.lockedRows, tr),
            otherRows = grid.rows,
            data, otherRow;

        if (!mainRow) {
            mainRow = grid.findByEl(grid.rows, tr);
            otherRows = grid.lockedRows;
        }

        data = mainRow.data;

        otherRow = otherRows.find(row => row.data === data);

        return mainRow.cells.concat(otherRow.cells);
    },

    getScrollEl() {
        return this.cmp.normalWrap.dom;
    },

    resetStyles() {
        this.cmp.el.query('.sa-grid-cell').forEach(el => {
            Ext.fly(el).setStyle({
                transform: null,
                transition: null
            });

            Ext.fly(el).removeCls('sa-report-grid-cell-row-drag');
        });
    },

    translateItemImpl(item, transform, transition) {
        var cells = this.getRowCellsByElement(item);

        Ext.fly(item).setStyle({transform, transition});

        cells.forEach(cell => {
            Ext.fly(cell.el).setStyle({transform, transition});
        });
    }
});